import {
  COOKIE_CONSENT_KEY,
  COOKIE_CONSENT_VALUES
} from 'shared/src/cookieConsent';

import { HJID, HJSV } from 'constants/environment';
import { getTrackingDeploymentMode } from 'constants/trackingEnvironment';

import { initializeHotjar } from './hotjar';

declare global {
  interface Window {
    initializeGoogleAnalytics?: () => void;
    initializeNewRelic?: () => void;
  }
}

export const hasTrackingConsent = () =>
  localStorage.getItem(COOKIE_CONSENT_KEY) === COOKIE_CONSENT_VALUES.Accepted;

export const initializeTracking = () => {
  const trackingDeploymentMode = getTrackingDeploymentMode(
    process.env.DEPLOYMENT_ENV
  );

  if (!hasTrackingConsent() || trackingDeploymentMode === 'disabled') {
    return;
  }

  window.initializeGoogleAnalytics?.();
  window.initializeNewRelic?.();

  if (HJID && HJSV) {
    initializeHotjar(HJID, HJSV, trackingDeploymentMode === 'debug');
  }
};
